<template>
    <view class="container ignore-none" @click="handleEvent">
        <slot></slot>
    </view>
</template>

<script setup lang="ts">
    import { playAudio } from '@/utils/public';
    import { useDebounceClick } from '@/hooks/debounceClick';

    const props = withDefaults(
        defineProps<{
            debounce?: boolean; // 是否开启防抖
            debounceTime?: number; // 防抖时间
        }>(),
        {
            debounce: true, // 默认不防抖

            debounceTime: 300, // 默认防抖时间 300ms





        }
    );

    // 简化抛出的事件，统一推荐父组件使用 @click 接收即可
    const emit = defineEmits<{
        (e: 'click', event: Event): void;
    }>();

    const executeInternalAction = () => {
        playAudio();
    };

    const rawHandler = (e: Event) => {
        executeInternalAction();
        // 统一向上抛出 click 事件
        emit('click', e);
    };

    const debouncedHandler = useDebounceClick(rawHandler, props.debounceTime);

    const handleEvent = (e: Event) => {
        if (props.debounce) {
            debouncedHandler(e);
        } else {
            rawHandler(e);
        }
    };
</script>

<style scoped lang="scss">
    .container {
        cursor: pointer;
        &:not(.nav-item):active {
            opacity: 0.7;
        }
    }
</style>
